import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=39bb65a8&scoped=true"
import script from "./previewImg.vue?vue&type=script&lang=js"
export * from "./previewImg.vue?vue&type=script&lang=js"
import style0 from "./previewImg.vue?vue&type=style&index=0&id=39bb65a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb65a8",
  null
  
)

export default component.exports